export default "__VITE_ASSET__D$Dn0FF2__"